/**
 * Períodos contables mensuales: estados, identificación del período de una
 * fecha y reglas de cierre. Un período cerrado no admite partidas nuevas;
 * las correcciones se hacen con partidas de reversa en un período abierto.
 */
import { keyedEnum } from '../catalogs/enum.js';
import { addDays, endOfMonth, startOfMonth } from '../calendar/iso-date.js';
/** Estados de un período contable. */
export const ACCOUNTING_PERIOD_STATUSES = ['open', 'closed'];
/** Catálogo con clave: `ACCOUNTING_PERIOD_STATUS.closed`. */
export const ACCOUNTING_PERIOD_STATUS = keyedEnum(ACCOUNTING_PERIOD_STATUSES);
/** Nombre en español de cada estado. */
export const ACCOUNTING_PERIOD_STATUS_LABELS = {
    open: 'Abierto',
    closed: 'Cerrado',
};
/** Período contable (primer día del mes) al que pertenece una fecha de negocio. */
export function accountingPeriodOf(date) {
    return startOfMonth(date);
}
/**
 * Fin de mes que debe ajustar el cierre nocturno de la fecha de negocio
 * dada, o `null` si no le toca. El cierre corre pasada la medianoche y
 * procesa el día que empieza; el primer cierre de cada mes es el que ve
 * completo el mes anterior, así que devenga y ajusta la estimación con
 * fecha del último día de ese mes.
 */
export function monthEndToClose(businessDate) {
    return startOfMonth(businessDate) === businessDate ? addDays(businessDate, -1) : null;
}
/**
 * ¿Se puede cerrar el período `period` en la fecha de negocio `today`? Solo
 * cuando el mes ya terminó: cerrar el mes en curso bloquearía la operación
 * del día.
 */
export function canClosePeriod(period, today) {
    return endOfMonth(period) < today;
}
//# sourceMappingURL=periods.js.map